import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getColumnDataKey, isExtraColumn, getColumnName } from '../column_helpers'
import LeagueRowComponent from './league_row_component'
import { FaIcon } from '../../shared/components'
import {
  GlgTable,
  GlgTableCol,
} from 'SharedComponents'
class LeaguesTableComponent extends PureComponent {
  getRowStyle() {
    return {
      borderLeft: `3px solid ${ this.props.categoryColor }`,
    }
  }

  getEmptyMessage() {
    if (this.props.categoryId) {
      return 'There are no events in this category.'
    } else {
      return 'There are no events.'
    }
  }

  render() {
    const sortingColumn = this.props.sortingColumn
    const rowExtraProps = {
      ...this.props.leagueActions,
      sortingColumn: getColumnDataKey(sortingColumn),
      sortingOrder: this.props.sortingOrder,
      includeCategoryColumn: this.props.includeCategoryColumn,
      userIsCustomerManager: this.props.userIsCustomerManager,
      userIsTourManager: this.props.userIsTourManager,
      userIsVisageAdmin: this.props.userIsVisageAdmin,
      showTours: this.props.showTours,
      toursEnabled: this.props.toursEnabled,
      showSeasonsColumn: this.props.showSeasonsColumn,
      seasonsEnabled: this.props.seasonsEnabled,
      showRegistration: this.props.showRegistration,
      golfHubEnabled: this.props.golfHubEnabled,
      isTmLite: this.props.isTmLite,
      userIsGroupLeader: this.props.userIsGroupLeader,
      hasPremiumRegistration: this.props.hasPremiumRegistration,
    }
    const userIsManager = this.props.userIsCustomerManager || this.props.userIsTourManager
    return (
      <GlgTable items={ this.props.leagues }
                rowComponent={ LeagueRowComponent }
                isSortable={ this.props.isSortable }
                onSortEnd={ this.props.reorderLeagues }
                maxHeight={ this.props.maxHeight }
                rowStyle={ this.getRowStyle() }
                rowExtraProps={ rowExtraProps }
                nestedId={ this.props.categoryId }
                emptyMessage={ this.getEmptyMessage() }>
        {this.props.isSortable && (
          <GlgTableCol width="3%" />
        )}
        <GlgTableCol width="25%" dataKey="name" cellProps={ { className: 'align-vertically'} } />
        {this.props.golfHubEnabled && !this.props.userIsGroupLeader &&(
          <GlgTableCol width="9%" dataKey="golfHub" cellProps={ { className: 'align-vertically'} }>
            Golf Hub Page
          </GlgTableCol>
        )}
        {userIsManager && this.props.includeCategoryColumn && (
          <GlgTableCol width="15%" dataKey="categoryName" cellProps={ { className: 'align-vertically'} }>
            Category
          </GlgTableCol>
        )}
        {userIsManager && this.props.showSeasonsColumn && (
          <GlgTableCol width="10%" dataKey="seasonName" cellProps={ { className: 'align-vertically'} }>
            Season
          </GlgTableCol>
        )}
        {userIsManager && this.props.showTours && (
          <GlgTableCol width="10%" dataKey="tourName" cellProps={ { className: 'align-vertically'} }>
            Tour
          </GlgTableCol>
        )}
        <GlgTableCol width="9%" dataKey="startDate" cellProps={ { className: 'align-vertically'} }>
          <FaIcon icon="calendar-alt" />
          <span className='add-margin-left-5'>
            Start Date
          </span>
        </GlgTableCol>
        <GlgTableCol width="15%" dataKey="golfers" cellProps={ { className: 'align-vertically'} }>
          <FaIcon icon="users" />
          <span className='add-margin-left-5'>
            Golfers
          </span>
        </GlgTableCol>
        {((!userIsManager && this.props.showRegistration) || (userIsManager && (this.props.hasPremiumRegistration || this.props.golfHubEnabled))) && (
          <GlgTableCol width="10%" dataKey="registrationMessage" cellProps={ { className: 'align-vertically'} }>
            Registration
          </GlgTableCol>
        )}
        {isExtraColumn(sortingColumn) && (
          <GlgTableCol width="10%"
                       dataKey={ sortingColumn }
                       cellProps={ { className: 'extra-column align-vertically' } }>
            { getColumnName(sortingColumn) }
          </GlgTableCol>
        )}
        <GlgTableCol width="6%" cellProps={ { className: 'align-vertically'} }>
          Actions
        </GlgTableCol>
      </GlgTable>
    )
  }
}

LeaguesTableComponent.propTypes = {
  leagues: PropTypes.array.isRequired,
  isSortable: PropTypes.bool.isRequired,
  categoryId: PropTypes.string,
  categoryColor: PropTypes.string,
  sortingColumn: PropTypes.string,
  sortingOrder: PropTypes.string,
  // Used for List View
  reorderLeagues: PropTypes.func.isRequired,
  leagueActions: PropTypes.object.isRequired,
  maxHeight: PropTypes.number,
  includeCategoryColumn: PropTypes.bool,
  userIsCustomerManager: PropTypes.bool.isRequired,
  userIsTourManager: PropTypes.bool.isRequired,
  userIsVisageAdmin: PropTypes.bool.isRequired,
  showTours: PropTypes.bool.isRequired,
  toursEnabled: PropTypes.bool.isRequired,
  showSeasonsColumn: PropTypes.bool.isRequired,
  seasonsEnabled: PropTypes.bool.isRequired,
  showRegistration: PropTypes.bool.isRequired,
  golfHubEnabled: PropTypes.bool,
  isTmLite: PropTypes.bool,
  userIsGroupLeader: PropTypes.bool,
  hasPremiumRegistration: PropTypes.bool,
}

export default LeaguesTableComponent
